<template>
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	:width=size :height="size" viewBox="0 0 28.427 28.428" style="enable-background:new 0 0 28.427 28.428;"
	 xml:space="preserve" >

        <circle  cx="14" cy="14" r="14" stroke="black" stroke-width="0.5" fill="green" class="jump">
        </circle>

        <g transform="translate(4 3) scale(0.7)" fill="white" stroke="black" >

            <path class="moveUp" d="M9.838,6.951c0-2.414,1.965-4.374,4.374-4.374c2.411,0,4.374,1.96,4.374,4.374v4.56h2.573v-4.56
                C21.16,3.116,18.044,0,14.212,0c-3.829,0-6.948,3.116-6.948,6.951v1.56h2.574V6.951z" />

            <path d="M22.586,12.97H5.843c-0.705,0-1.287,0.582-1.287,1.293v12.875c0,0.708,0.582,1.29,1.287,1.29h16.743
                c0.705,0,1.285-0.582,1.285-1.29V14.263C23.872,13.552,23.292,12.97,22.586,12.97z"/>


            <circle  cx="16" cy="21" r="1" stroke="black" stroke-width="0.5" fill="#501078 " />
            <circle  cx="12" cy="21" r="1" stroke="black" stroke-width="0.5" fill="#501078 "/>

        </g>
    </svg>
</template>

<script>
    export default {
        name: "si_unlock",
        props:{
            size:{
                type: String,
                default: '48px'
            }
        }
    }
</script>

<style scoped lang="scss">

    @keyframes jump {
        0%   {transform: translate3d(0,0,0) scale3d(1,1,1);}
        40%  {transform: translate3d(0,30%,0) scale3d(.7,1.5,1);}
        100% {transform: translate3d(0,100%,0) scale3d(1.5,.7,1);}
    }
    .jump {
        transform-origin: 50% 50%;
        animation: jump .5s linear alternate infinite;
    }






</style>